import { Injectable, inject } from "@angular/core";
import Decimal from "decimal.js";
import { AlertsService } from "./alerts.service";
import { QUERY_COST_CURRENCY, QUERY_COST_THRESHOLD } from "../constant/queries";
interface QueryMetadata {
  job_id?: string;
  cost?: string;
}
type QueryLog = { [path: string]: { [queryId: string]: string } };
@Injectable({
  providedIn: "root",
})
export class VcloudCostTrackerService {
  private alerts: AlertsService = inject(AlertsService);

  public getTotalQueryCost(type: "all" | "bq" | "llm", reportPage: string): Decimal {
    let totalCost: Decimal = new Decimal(0);
    const queriesStr: string | null = sessionStorage.getItem("expensiveQueries");
    if (queriesStr) {
      const queries: QueryLog = JSON.parse(queriesStr);
      if (queries !== undefined && queries !== null) {
        for (const path in queries) {
          if (reportPage && path !== reportPage) {
            continue;
          }
          const page: { [queryId: string]: string } = queries[path];
          if (page !== undefined && page !== null) {
            for (const queryId in page) {
              if (type === "all" || queryId.startsWith(type)) {
                totalCost = totalCost.add(page[queryId] ?? "0");
              }
            }
          }
        }
      }
    }
    return totalCost;
  }

  public getTotalQueryCount(): number {
    let totalQueries: number = 0;
    const queriesStr: string | null = sessionStorage.getItem("expensiveQueries");
    if (queriesStr) {
      const queries: QueryLog = JSON.parse(queriesStr);
      if (queries !== undefined && queries !== null) {
        for (const page in queries) {
          for (const _ in queries[page]) {
            totalQueries++;
          }
        }
      }
    }
    return totalQueries;
  }

  public getThisReportQueries(): number {
    let totalQueries: number = 0;
    const queriesStr: string | null = sessionStorage.getItem("expensiveQueries");
    if (queriesStr) {
      const queries: QueryLog = JSON.parse(queriesStr);
      if (queries !== undefined && queries !== null && location.pathname in queries) {
        for (const _ in queries[location.pathname]) {
          totalQueries++;
        }
      }
    }
    return totalQueries;
  }

  public handleQueryCost({ Metadata: { job_id: jobId, cost: c } }: { Metadata: QueryMetadata }): void {
    const cost: Decimal = new Decimal((c ?? `0.0 ${QUERY_COST_CURRENCY}`).split(" ")[0] ?? "0.0");
    const queryLog: QueryLog = JSON.parse(sessionStorage.getItem("expensiveQueries") ?? "{}") ?? {};
    if (location.pathname in queryLog) {
      queryLog[location.pathname][jobId ?? "???"] = cost.toString();
    } else {
      queryLog[location.pathname] = { [jobId ?? "???"]: cost.toString() };
    }
    sessionStorage.setItem("expensiveQueries", JSON.stringify(queryLog));
    if (cost.gte(QUERY_COST_THRESHOLD)) {
      this.alerts.addAlert({
        text: `<p><strong>Expensive Query!!!</strong><br><br>Consumed ${cost
          .toDecimalPlaces(2)
          .toNumber()} ${QUERY_COST_CURRENCY}. Job ID: ${
          jobId ?? "???"
        }. You must optimise your query or reach out to someone working on the backend.</p>`,
        type: "danger",
        dismissOnTimeout: 20000,
        dismissible: true,
      });
    }
  }
}
